import { HttpLink } from '@apollo/client'

import { railsContext } from 'Const'

const httpLink = new HttpLink({
  uri: railsContext.serverSide ? '' : '/graphql',
  // @ts-ignore: fetch is not defined on server side
  fetch: railsContext.serverSide ? async () => {} : fetch,
})

export default httpLink
